import Skeleton from 'react-loading-skeleton'
import Section from 'src/components/sections/Section'
import 'src/components/sections/ProductShelf/product-shelf.scss'
import 'react-loading-skeleton/dist/skeleton.css'
import type { PropsWithChildren } from 'react'

interface Props {
  loading?: boolean
  title?: boolean
}

function ProductShelfSkeleton({
  children,
  loading = true,
  title = true,
}: PropsWithChildren<Props>) {
  const quantityDesktop = 4
  const quantityMobile = 2

  return loading ? (
    <>
      <Section className="layout__content layout__section shelf-section p-0 m-0 hidden sm:block">
        {title && (
          <h2 className="mb-8 max-w-xs md:h-[62px]">
            <Skeleton />
          </h2>
        )}
        <ul
          data-product-shelf
          className="layout__content !gap-x-2 sm:!gap-x-6 p-0"
        >
          {Array.from({ length: quantityDesktop }, (_, index) => (
            <li key={String(index)} className="md:h-[455px] h-[309px]">
              <Skeleton className="md:h-[455px] h-[309px]" />
            </li>
          ))}
        </ul>
      </Section>
      <Section className="layout__content layout__section shelf-section p-0 m-0 sm:hidden">
        {title && (
          <h2 className="mb-8 max-w-xs md:h-[62px]">
            <Skeleton />
          </h2>
        )}
        <ul
          data-product-shelf
          className="layout__content !gap-x-2 sm:!gap-x-6 p-0"
        >
          {Array.from({ length: quantityMobile }, (_, index) => (
            <li key={String(index)} className="md:h-[455px] h-[309px]">
              <Skeleton className="md:h-[455px] h-[309px]" />
            </li>
          ))}
        </ul>
      </Section>
    </>
  ) : (
    <>{children}</>
  )
}

export default ProductShelfSkeleton
